import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
@Injectable({
  providedIn: 'root'
})
export class AppMonitoringService {
  appInsights: ApplicationInsights | null = null;
  private enabled: boolean = false;

  constructor() {
    this.enabled = environment.appInsights?.enabled ?? false;
    
    if (this.enabled && environment.appInsights?.instrumentationKey) {
      this.appInsights = new ApplicationInsights({
        config: {
          instrumentationKey: environment.appInsights.instrumentationKey,
          enableAutoRouteTracking: true // option to log all route changes
        }
      });
      this.appInsights.loadAppInsights();
    }
  }

  logPageView(name?: string, url?: string) { // option to call manually
    if (!this.enabled || !this.appInsights) return;
    this.appInsights.trackPageView({
      name: name,
      uri: url
    });
  }

  logEvent(name: string, properties?: { [key: string]: any }) {
    if (!this.enabled || !this.appInsights) return;
    this.appInsights.trackEvent({ name: name}, properties);
  }

  logMetric(name: string, average: number, properties?: { [key: string]: any }) {
    if (!this.enabled || !this.appInsights) return;
    this.appInsights.trackMetric({ name: name, average: average }, properties);
  }

  logException(exception: Error, severityLevel?: number) {
    if (!this.enabled || !this.appInsights) return;
    this.appInsights.trackException({ exception: exception, severityLevel: severityLevel });
  }

  logTrace(message: string, properties?: { [key: string]: any }) {
    if (!this.enabled || !this.appInsights) return;
    this.appInsights.trackTrace({ message: message}, properties);
  }

}
